import type {UseMessagesReturn} from '@/components/ChatSection/hooks/useMessages'
import {useLocale} from '@/lib/locale/locale'
import {useProductSuspense} from '@/lib/product/hooks/useProduct'
import {type RawMinimalProduct} from '@/models/productModel'

import ProductCard from './ProductCard'
import ProductCardPlaceholder from './ProductCardPlaceholder'

interface Props {
  rawMinimalProduct: RawMinimalProduct
  submitMessage: UseMessagesReturn['submitMessage']
}

function SuspensedProduct({rawMinimalProduct, submitMessage}: Props) {
  const [locale] = useLocale()

  const {data: product} = useProductSuspense({
    retailer: rawMinimalProduct.retailer,
    id: rawMinimalProduct.id,
    locale,
  })

  return product ? (
    <ProductCard product={product} isInMessage submitMessage={submitMessage} headingLevel={2} />
  ) : null
}

export default memo<Props>(function MinimalProductCard(props) {
  return (
    // <ProductCardPlaceholder />
    <Suspense fallback={<ProductCardPlaceholder />}>
      <SuspensedProduct {...props} />
    </Suspense>
  )
})
